import ComponentTypes from '@theme-original/NavbarItem/ComponentTypes';
import BlogLinkNavbarItem from './BlogLinkNavbarItem';
import DocsLinkNavbarItem from './DocsLinkNavbarItem';

export default {
  ...ComponentTypes,
  'custom-blogLink': BlogLinkNavbarItem,
  'custom-docsLink': DocsLinkNavbarItem,
};
